var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFloodIns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Flood",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 27.997,
    viewBox: "0 0 30 27.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13382",
    "data-name": "Group 13382",
    transform: "translate(0 5.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31536",
    "data-name": "Path 31536",
    d: "M286.949,1509.147a.479.479,0,0,1-.124.353c-.313.376-.676.066-.83-.068a12.676,12.676,0,0,0-5.42-2.77,10.019,10.019,0,0,0-6.486.658,5.033,5.033,0,0,0-2.542,2.452c-.131.271-.205.463-.058.662s.323.183.626.093a4.19,4.19,0,0,1,.473-.1.723.723,0,0,1,.656.115.708.708,0,0,1,.056.638,3,3,0,0,0-.092.743v.023c0,.275.006.448.211.52.156.055.235-.028.371-.193.025-.03.05-.06.076-.088a3.228,3.228,0,0,1,2.849-1.248,3.3,3.3,0,0,1,2.181,1.117,5.678,5.678,0,0,1,1.15,4.8,5.55,5.55,0,0,1-2.8,4,5.032,5.032,0,0,1-2.27.549,5.382,5.382,0,0,1-1.594-.248,11.886,11.886,0,0,0-3.514-.691h-.021a.829.829,0,0,1-.487-.189c-.031-.02-.061-.042-.093-.062l-.056-.035v-.5l.06-.035a2.108,2.108,0,0,1,1.478-.13c.119.019.244.04.363.052a12.2,12.2,0,0,1,2.157.5l.208.061a4.372,4.372,0,0,0,4.264-.8,4.666,4.666,0,0,0,1.34-4.272,6.152,6.152,0,0,0-.357-1.424,2.586,2.586,0,0,0-1.894-1.69,2.507,2.507,0,0,0-2.289.979,1.234,1.234,0,0,1-1.419.5,1.272,1.272,0,0,1-.888-1.247c0-.039-.006-.078-.009-.117a1.283,1.283,0,0,1,0-.329c.022-.129,0-.153,0-.154s-.03-.024-.189-.018a1.516,1.516,0,0,1-1.424-.6,1.6,1.6,0,0,1,.032-1.576,6.681,6.681,0,0,1,4.8-3.6c3.979-.978,7.639-.03,11.188,2.9A.763.763,0,0,1,286.949,1509.147Z",
    transform: "translate(-269.213 -1505.403)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13383",
    "data-name": "Group 13383",
    transform: "translate(0 22.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31537",
    "data-name": "Path 31537",
    d: "M290.731,1592.836a5.836,5.836,0,0,1-3.506,1.067,5.619,5.619,0,0,1-3.052-.975,4.791,4.791,0,0,0-4.026-.648,4.712,4.712,0,0,0-1.285.61l-.267.16a5.888,5.888,0,0,1-3,.877,5.785,5.785,0,0,1-2.986-.881,5.08,5.08,0,0,0-2.744-.931.862.862,0,0,1-.447-.14c-.046-.025-.091-.05-.138-.07l-.072-.031v-.5l.046-.036a1.554,1.554,0,0,1,1.431-.158c.12.027.236.053.35.07a5.206,5.206,0,0,1,1.878.829l.09.054a4.593,4.593,0,0,0,5.165.006,5.734,5.734,0,0,1,6.607-.011,4.617,4.617,0,0,0,5.215-.014l.071-.043c.061-.039.123-.077.185-.112.426-.243.638-.029.728.119C291.146,1592.358,291.062,1592.612,290.731,1592.836Z",
    transform: "translate(-269.213 -1591.079)",
    fill: "#ffb600"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13384",
    "data-name": "Group 13384",
    transform: "translate(0 25.182)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31538",
    "data-name": "Path 31538",
    d: "M279.016,1607.089a5.863,5.863,0,0,1-2.886,1.1c-.179.012-.354.018-.525.018a5.135,5.135,0,0,1-2.824-.76,5.446,5.446,0,0,0-3.058-1.057.847.847,0,0,1-.311-.076,1.1,1.1,0,0,0-.116-.042l-.084-.025v-.659l.08-.029a3.669,3.669,0,0,1,2.693.3,6.145,6.145,0,0,1,.82.444c.107.066.216.133.326.2a4.649,4.649,0,0,0,4.964-.017l.151-.09c.086-.052.171-.1.257-.152.392-.221.609-.051.722.131A.486.486,0,0,1,279.016,1607.089Z",
    transform: "translate(-269.213 -1605.406)",
    fill: "#ffb600"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13385",
    "data-name": "Group 13385",
    transform: "translate(10.443 25.144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31539",
    "data-name": "Path 31539",
    d: "M344.251,1607.6c-.053.453-.5.447-.651.449a5.833,5.833,0,0,1-3.2-1.083,4.611,4.611,0,0,0-3.587-.61,4.729,4.729,0,0,0-1.568.695,6.1,6.1,0,0,1-3.25,1.021,5.864,5.864,0,0,1-3.191-1.012,4.882,4.882,0,0,0-3.4-.773.69.69,0,0,1-.54-.084.486.486,0,0,1-.162-.354c-.028-.327.164-.512.571-.551.208-.02.416-.029.62-.036l.267-.012a5.827,5.827,0,0,1,3.426,1.125,4.579,4.579,0,0,0,3.875.461,4.741,4.741,0,0,0,1.148-.563c.131-.08.262-.159.4-.235a5.48,5.48,0,0,1,5.768,0,5.8,5.8,0,0,0,2.905,1.013h0a.6.6,0,0,1,.475.172A.462.462,0,0,1,344.251,1607.6Z",
    transform: "translate(-324.699 -1605.216)",
    fill: "#ffb600"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13386",
    "data-name": "Group 13386",
    transform: "translate(22.517)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31540",
    "data-name": "Path 31540",
    d: "M389.2,1479.312a1.564,1.564,0,0,0-1.131-.482h-.009a1.684,1.684,0,0,0-1.237.568,1.444,1.444,0,0,0-.364,1.1c.179,1.777.431,3.576.675,5.316l.034.24a.851.851,0,0,0,.9.766h.01a.852.852,0,0,0,.9-.778c.189-1.344.363-2.705.531-4.021q.092-.722.185-1.436v-.013A1.764,1.764,0,0,0,389.2,1479.312Zm-1.276,5.079c-.161-1.254-.329-2.552-.475-3.83a.693.693,0,0,1,.152-.545.6.6,0,0,1,.462-.2h.01a.609.609,0,0,1,.465.209.712.712,0,0,1,.15.555c-.147,1.273-.315,2.567-.477,3.819q-.073.555-.144,1.113Q387.991,1484.95,387.919,1484.391Z",
    transform: "translate(-386.445 -1478.83)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13387",
    "data-name": "Group 13387",
    transform: "translate(19.745 12.965)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31541",
    "data-name": "Path 31541",
    d: "M382.5,1550.194a.5.5,0,0,1-.143.36.694.694,0,0,1-.532.107,1.058,1.058,0,0,0-.249,0l-.015,0h-.016c-3.851-.255-6.836-2.123-9.123-5.708a.729.729,0,0,1-.146-.535.485.485,0,0,1,.256-.3c.392-.218.595.11.716.306l.032.052a11.182,11.182,0,0,0,4.492,4.208,9.989,9.989,0,0,0,3.8.984,1.78,1.78,0,0,0,.208,0,.745.745,0,0,1,.594.127A.516.516,0,0,1,382.5,1550.194Z",
    transform: "translate(-372.268 -1544.05)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13388",
    "data-name": "Group 13388",
    transform: "translate(22.012 22.335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31542",
    "data-name": "Path 31542",
    d: "M391.849,1593.508c-.031.423-.4.455-.6.455H391.2a4.58,4.58,0,0,1-2.586-.717,5.4,5.4,0,0,0-4.1-1,.6.6,0,0,1-.5-.084.475.475,0,0,1-.159-.352c-.019-.322.173-.506.572-.551.268-.03.535-.058.741-.08l.179-.019h.007a5.507,5.507,0,0,1,3,.8,4.932,4.932,0,0,0,2.894,1.005.594.594,0,0,1,.463.161A.494.494,0,0,1,391.849,1593.508Z",
    transform: "translate(-383.863 -1591.158)",
    fill: "#ffb600"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13389",
    "data-name": "Group 13389",
    transform: "translate(22.72 8.284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31543",
    "data-name": "Path 31543",
    d: "M389.911,1520.908a1.385,1.385,0,0,0-1-.441H388.9a1.436,1.436,0,0,0-1.412,1.4,1.462,1.462,0,0,0,.4,1.036,1.429,1.429,0,0,0,.464.329,1.357,1.357,0,0,0,.541.118h.007a1.446,1.446,0,0,0,1.011-2.444Zm-1,1.454c-.31-.058-.453-.216-.439-.482a.4.4,0,0,1,.421-.416.445.445,0,0,1,.328.122.458.458,0,0,1,.115.327A.443.443,0,0,1,388.907,1522.362Z",
    transform: "translate(-387.486 -1520.467)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13390",
    "data-name": "Group 13390",
    transform: "translate(18.489 10.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31544",
    "data-name": "Path 31544",
    d: "M366.13,1533.593a.437.437,0,0,1-.329.156h-.029c-.342,0-.564-.221-.66-.657-.059-.27.1-.474.431-.558l.026-.007.027.006a.8.8,0,0,1,.623.719A.434.434,0,0,1,366.13,1533.593Z",
    transform: "translate(-365.1 -1532.526)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13392",
    "data-name": "Group 13392",
    transform: "translate(23.776 9.279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31546",
    "data-name": "Path 31546",
    d: "M393.369,1525.9a.443.443,0,0,1-.426.45c-.31-.058-.453-.216-.439-.482a.4.4,0,0,1,.421-.416.445.445,0,0,1,.328.122A.46.46,0,0,1,393.369,1525.9Z",
    transform: "translate(-392.504 -1525.456)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloodIns);
export default __webpack_public_path__ + "static/media/Flood-ins.a98435a77ba64d51853005f26c6d38a0.svg";
export { ForwardRef as ReactComponent };